export default __webpack_public_path__ + "static/media/sent-icon.ca2b49c4.svg";